import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'si-sms-verification-dialog',
  templateUrl: './sms-verification-dialog.component.html',
  styleUrls: ['./sms-verification-dialog.component.scss']
})
export class SmsVerificationDialogComponent {
  @Input() displayDialog: boolean;
  @Input() phoneValue: string;
  @Input() smsVerificationCode: string;
  @Input() smsVerificationErrorText: string;
  @Output() displayDialogChange = new EventEmitter<boolean>();
  @Output() smsVerificationCodeChange = new EventEmitter<string>();

  onChangeDisplayDialog(displayDialog: boolean): void {
    this.displayDialogChange.emit(displayDialog);
  }

  onClickValidate(): void {
    this.smsVerificationCodeChange.emit(this.smsVerificationCode);
  }
}
